export const KEY_GET_DELEGATES = 'get.delegates.call';
export const KEY_POST_CREATE_DELEGATE_GUEST = 'post.delegate-guest.call';
export const KEY_POST_CREATE_DELEGATE_EMPLOYER = 'post.delegate-employer.call';
export const KEY_DELETE_DELEGATE = 'delete.delegate.call';
export const KEY_POST_DELEGATE_ACTIVATION_EMAIL = 'post.delegate-activation-email.call';
export const KEY_GET_ORGANIZATION_CREDITS = 'get.organization-credits.call';
export const KEY_GET_ORGANIZATION_CREDITS_QUARTER = 'get.organization-credits-quarter.call';
